import React, { Component } from "react";
import { history } from "../../../helper/history.js";
import { AzureStorageManage } from "../../../helper/azureStorageManage.js";
import config from "../../../helper/config.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import CardBody from "../../../components/common/CardBody.js";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { VideoService } from "../../../service/manage/video_streaming/video_service.js";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import { customerConstants } from "../../../helper/constants.js";
import DeleteIcon from "@mui/icons-material/Delete";
import ManageVideoStream from "./ManageVideoStream.js";
import { duration } from "moment";
import VideoCollectionSkeleton from "./VideoCollectionSkeleton.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let cancelClass, confirmClass;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    cancelClass = "btn-default";
    confirmClass = "btn-primary";
    break;
  case customerConstants.EXO_CUSTOMER2:
  default:
    cancelClass = "btn-default";
    confirmClass = "btn-primary";
    break;
}

const DOCUMENT_TYPES = {
  RECORDINGS: { name: "Videos", icon: "🎥", color: "#ea4335" },
};

const ALLOWED_FILE_TYPES = [
  "video/mp4", // MP4
  "video/quicktime", // MOV
];

class ManageVideos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topics: [],
      topicDocuments: new Map(), // topic_id -> documents array
      expandedTopics: new Set(), // Set of expanded topic IDs
      showTopicModal: false,
      editingTopic: null,
      topicFormData: {
        topic_name: "",
        topic_description: "",
      },
      showDocumentModal: false,
      selectedDocumentType: "",
      selectedTopic: null,
      selectedFile: null,
      selectedFiles: [],
      allSelected: false,
      loading: false,
      loadingModal: false,
      userType: null,
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      viewVisibility: false,
      node_id: "",
      manage_user_id: "",
      user_table_id: "",
      breadcrumb2: null,
      nodeTitle: null,
      showVideoStream: false,
      selectedTopicData: null,

      uploadProgress: 0,
      uploadStatus: null, // 'uploading', 'success', 'error', 'cancelled'
      uploadSpeed: 0,
      timeRemaining: null,
      uploadedBytes: 0,
      totalBytes: 0,
      uploadError: null,
      isUploading: false,
      uploadSessionId: null,
      canRetry: false,
      canCancel: false,
      uploadStartTime: null,
    };
    // Upload control
    this.uploadController = null;
    this.uploadIntervalId = null;
  }

  componentDidMount() {
    this.initializeComponent();
  }

  initializeComponent = async () => {
    const { privilege_view, privilege_add, privilege_edit, privilege_delete } =
      this.props.state;

    this.setUserPermissions(
      privilege_view,
      privilege_add,
      privilege_delete,
      privilege_edit
    );

    const userType = sessionStorage.getItem("userType");
    const node_mid_actual =
      this.props.state.node_mid_actual !== null
        ? this.props.state.node_mid_actual
        : this.props.state.mid;

    this.setState({
      userType,
      node_id: node_mid_actual,
      manage_user_id: sessionStorage.getItem("manage_user_id"),
      user_table_id: sessionStorage.getItem("table_log_id"),
      breadcrumb2: this.props.state.breadcrumb2,
      nodeTitle: this.props.state.breadcrumb2,
    });

    await this.loadTopicsAndDocuments();
  };

  setUserPermissions = (
    privilege_view,
    privilege_add,
    privilege_delete,
    privilege_edit
  ) => {
    this.setState({
      addVisibility: privilege_add === 1,
      editVisibility: privilege_edit === 1,
      viewVisibility: privilege_view === 1,
      deleteVisibility: privilege_delete === 1,
    });
  };

  loadTopicsAndDocuments = async () => {
    this.setState({ loading: true });

    try {
      const node_id = this.props.state.mid;
      // Load topics and documents in parallel for better performance
      const [topicsResponse, documentsResponse] = await Promise.all([
        VideoService.getTopicsByNodeId(node_id),
        this.getDocumentsByContainerId(),
      ]);

      const topics = topicsResponse.data || [];
      const documents = documentsResponse.data || [];

      // Efficiently map documents to topics
      const topicDocuments = this.mapDocumentsToTopics(topics, documents);

      // Auto-expand topics that have documents
      const expandedTopics = new Set(
        topics
          .filter((topic) => topicDocuments.get(topic.topic_id)?.length > 0)
          .map((topic) => topic.topic_id)
      );

      this.setState({
        topics,
        topicDocuments,
        expandedTopics,
      });
    } catch (error) {
      console.error("Error loading topics and documents:", error);
      this.showErrorMessage("Failed to load content. Please try again.");
    } finally {
      this.setState({ loading: false });
    }
  };

  getDocumentsByContainerId = async () => {
    const NodeId =
      this.props.state.node_mid_actual !== null
        ? this.props.state.node_mid_actual
        : this.props.state.mid;

    const form_list = this.props.state.form_list_id;
    const containerId = `${NodeId}_${form_list}`
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/^-+|-+$/g, "");

    return VideoService.getVideosByContainerId(containerId);
  };

  mapDocumentsToTopics = (topics, documents) => {
    const topicDocuments = new Map();

    // Initialize all topics with empty arrays
    topics.forEach((topic) => {
      topicDocuments.set(topic.topic_id, []);
    });

    // Group documents by topic_id with O(n) efficiency
    documents.forEach((doc) => {
      const topicId = doc.topic_id;
      if (topicDocuments.has(topicId)) {
        topicDocuments.get(topicId).push(doc);
      } else {
        // Handle documents without valid topic_id - create "Uncategorized" topic
        if (!topicDocuments.has(0)) {
          topicDocuments.set(0, []);
        }
        topicDocuments.get(0).push(doc);
      }
    });

    return topicDocuments;
  };

  // Collection Management Methods
  handleCreateTopic = () => {
    this.setState({
      showTopicModal: true,
      editingTopic: null,
      topicFormData: {
        topic_name: "",
        topic_description: "",
      },
    });
  };

  handleEditTopic = (topic) => {
    this.setState({
      showTopicModal: true,
      editingTopic: topic,
      topicFormData: {
        topic_name: topic.topic_name,
        topic_description: topic.topic_description,
      },
    });
  };

  handleTopicFormChange = (field, value) => {
    this.setState((prevState) => ({
      topicFormData: {
        ...prevState.topicFormData,
        [field]: value,
      },
    }));
  };

  handleTopicSubmit = async () => {
    const {
      topicFormData,
      editingTopic,
      node_id,
      manage_user_id,
      user_table_id,
    } = this.state;

    if (!topicFormData.topic_name.trim()) {
      this.showErrorMessage("Collection name is required!");
      return;
    }

    this.setState({ loadingModal: true });

    const payload = {
      topic_name: topicFormData.topic_name.trim(),
      topic_description: topicFormData.topic_description.trim(),
      node_id: node_id,
      create_user_id: manage_user_id,
      create_user_table_id: user_table_id,
    };

    try {
      if (editingTopic) {
        await VideoService.updateTopic(editingTopic.topic_id, payload);
        this.showSuccessMessage(
          `Collection "${payload.topic_name}" updated successfully!`
        );
      } else {
        await VideoService.addTopic(payload);
        this.showSuccessMessage(
          `Collection "${payload.topic_name}" created successfully!`
        );
      }

      this.handleCloseTopicModal();
      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Error saving topic:", error);
      this.showErrorMessage("Failed to save topic. Please try again.");
    } finally {
      this.setState({ loadingModal: false });
    }
  };

  handleCloseTopicModal = () => {
    this.setState({
      showTopicModal: false,
      editingTopic: null,
      topicFormData: {
        topic_name: "",
        topic_description: "",
      },
    });
  };

  toggleTopicExpansion = (topicId) => {
    this.setState((prevState) => {
      const expandedTopics = new Set(prevState.expandedTopics);
      if (expandedTopics.has(topicId)) {
        expandedTopics.delete(topicId);
      } else {
        expandedTopics.add(topicId);
      }
      return { expandedTopics };
    });
  };

  // Document Management Methods
  handleCreateDocument = (topic) => {
    this.setState({
      showDocumentModal: true,
      selectedTopic: topic,
      selectedDocumentType: "",
      selectedFile: null,
    });
  };

  // Updated handleDocumentTypeSelect method
  handleDocumentTypeSelect = (documentType) => {
    if (!this.state.selectedFile) {
      this.setState({
        selectedDocumentType: documentType,
        selectedFile: null,
      });
    }
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];

    console.log("Uploaded file type:", file.type);

    if (!file) return;

    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      this.showErrorMessage(
        "Only video files are allowed! Supported formats: MP4, MOV"
      );
      return;
    }

    // Reset upload states
    this.resetUploadStates();

    this.setState({
      selectedFile: file,
      totalBytes: file.size,
    });
  };

  // Format upload speed
  formatSpeed = (bytesPerSecond) => {
    if (bytesPerSecond < 1024) return `${bytesPerSecond.toFixed(0)} B/s`;
    if (bytesPerSecond < 1024 * 1024)
      return `${(bytesPerSecond / 1024).toFixed(1)} KB/s`;
    return `${(bytesPerSecond / (1024 * 1024)).toFixed(1)} MB/s`;
  };

  formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    if (bytes < 1024 * 1024 * 1024)
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  };

  // Format time remaining
  formatTimeRemaining = (seconds) => {
    if (!seconds || seconds === Infinity || seconds < 0)
      return "Calculating...";
    if (seconds < 60) return `${Math.round(seconds)}s`;
    if (seconds < 3600)
      return `${Math.floor(seconds / 60)}m ${Math.round(seconds % 60)}s`;
    return `${Math.floor(seconds / 3600)}h ${Math.floor(
      (seconds % 3600) / 60
    )}m`;
  };
  // Cancel upload
  cancelUpload = () => {
    if (this.uploadController) {
      this.uploadController.abort();
    }

    this.setState({
      uploadStatus: "cancelled",
      isUploading: false,
      canCancel: false,
      canRetry: true,
    });
  };

  // Retry upload
  retryUpload = () => {
    this.resetUploadStates();
    this.handleDocumentUpload();
  };

  // Enhanced reset method
  resetUploadStates = () => {
    // Cancel any ongoing upload
    if (this.uploadController) {
      this.uploadController.abort();
      this.uploadController = null;
    }

    this.setState({
      uploadProgress: 0,
      uploadStatus: null,
      uploadSpeed: 0,
      timeRemaining: null,
      uploadedBytes: 0,
      uploadError: null,
      isUploading: false,
      uploadSessionId: null,
      canRetry: false,
      canCancel: false,
      uploadStartTime: null,
    });
  };

  // Add this helper method to extract video duration
  getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        // Return duration in seconds with 2 decimal precision
        resolve(Math.round(video.duration * 100) / 100);
      };

      video.onerror = () => {
        window.URL.revokeObjectURL(video.src);
        reject(new Error("Failed to load video metadata"));
      };

      video.src = window.URL.createObjectURL(file);
    });
  };

  // Add this helper method to calculate file size in MB
  getFileSizeInMB = (file) => {
    // Convert bytes to MB with 2 decimal precision
    return Math.round((file.size / (1024 * 1024)) * 100) / 100;
  };

  handleDocumentUpload = async () => {
    const {
      selectedFile,
      selectedDocumentType,
      selectedTopic,
      node_id,
      manage_user_id,
      user_table_id,
    } = this.state;

    if (!selectedFile || !selectedDocumentType || !selectedTopic) {
      this.showErrorMessage("Please select a file and document type!");
      return;
    }

    if (selectedFile.size > config.fileUploadConfigs.maxVideoFileSize) {
      this.showErrorMessage("File size exceeds maximum allowed limit!");
      return;
    }

    // Create abort controller for this upload
    this.uploadController = new AbortController();

    // Generate unique upload session ID
    const uploadSessionId = `upload_${Date.now()}_${Math.random()
      .toString(36)
      .substr(2, 9)}`;

    // Reset and start upload
    this.setState({
      isUploading: true,
      uploadStatus: "uploading",
      canCancel: true,
      canRetry: false,
      uploadStartTime: Date.now(),
      uploadSessionId: uploadSessionId,
      uploadProgress: 0,
      uploadedBytes: 0,
      totalBytes: selectedFile.size,
      uploadSpeed: 0,
      timeRemaining: null,
      uploadError: null,
    });

    const form_list = this.props.state.form_list_id;
    const container_id = `${node_id}_${form_list}`
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/^-+|-+$/g, "");

    const originalName = selectedFile.name;
    const timestamp = Date.now(); 
    const fileExtension = originalName.substring(originalName.lastIndexOf('.'));
    const fileNameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));
    const uniqueName = `${fileNameWithoutExt}_${timestamp}${fileExtension}`;

    try {
      // Extract video metadata before upload
      let videoDuration = null;
      let fileSizeInMB = null;

      try {
        // Calculate file size in MB
        fileSizeInMB = this.getFileSizeInMB(selectedFile);

        // Extract video duration (only for video files)
        if (selectedFile.type.startsWith("video/")) {
          videoDuration = await this.getVideoDuration(selectedFile);
        }
      } catch (metadataError) {
        console.warn("Failed to extract video metadata:", metadataError);
        // Continue with upload even if metadata extraction fails
        fileSizeInMB = this.getFileSizeInMB(selectedFile); // At least get the file size
      }

      // Real-time progress callback
      const progressCallback = (progressData) => {
        const { loaded, total, percentage } = progressData;
        const currentTime = Date.now();
        const { uploadStartTime } = this.state;

        if (uploadStartTime) {
          const elapsedTime = (currentTime - uploadStartTime) / 1000; // seconds
          const uploadSpeed = elapsedTime > 0 ? loaded / elapsedTime : 0; // bytes per second
          const remainingBytes = total - loaded;
          const timeRemaining =
            uploadSpeed > 0 ? Math.ceil(remainingBytes / uploadSpeed) : null;

          this.setState({
            uploadProgress: percentage,
            uploadedBytes: loaded,
            uploadSpeed: uploadSpeed,
            timeRemaining: timeRemaining,
          });
        }
      };

      // Upload to Azure Blob Storage with real progress
      const requestId = await AzureStorageManage.uploadBlobWithProgress(
        container_id,
        uniqueName,
        selectedFile,
        progressCallback,
        this.uploadController
      );

      // Check if upload was cancelled during the process
      if (this.uploadController.signal.aborted) {
        return;
      }

      // Save to database with enhanced data
      await VideoService.addVideo({
        video_name: uniqueName,
        node_id: node_id,
        container_id: container_id,
        user_id: manage_user_id,
        user_table_id: user_table_id,
        create_user_id: manage_user_id,
        create_user_table_id: user_table_id,
        video_type: selectedDocumentType,
        topic_id: selectedTopic.topic_id,
        duration: videoDuration, // Duration in seconds (null for non-video files)
        size_mb: fileSizeInMB, // File size in MB with 2 decimal precision
      });

      // Upload completed successfully
      this.setState({
        uploadStatus: "success",
        isUploading: false,
        canCancel: false,
        uploadProgress: 100,
        uploadedBytes: this.state.totalBytes,
        timeRemaining: 0,
      });

      this.showSuccessMessage(
        `${DOCUMENT_TYPES[selectedDocumentType].name} "${uniqueName}" uploaded successfully!`
      );

      // Auto-close modal after success
      setTimeout(() => {
        this.handleCloseDocumentModal();
        this.loadTopicsAndDocuments();
      }, 3000);
    } catch (error) {
      console.error("Upload error:", error);

      // Handle different error types
      if (
        error.message === "Upload cancelled by user" ||
        error.name === "AbortError"
      ) {
        this.setState({
          uploadStatus: "cancelled",
          isUploading: false,
          canCancel: false,
          canRetry: true,
        });
        return;
      }

      // Handle other errors
      this.setState({
        uploadStatus: "error",
        uploadError:
          error.message || "An unexpected error occurred during upload",
        isUploading: false,
        canCancel: false,
        canRetry: true,
      });

      this.showErrorMessage(`Upload failed: ${error.message}`);
    } finally {
      // Clean up
      this.uploadController = null;
    }
  };

  handleCloseDocumentModal = () => {
    if (this.state.isUploading) {
      const confirmClose = window.confirm(
        "Upload is in progress. Are you sure you want to cancel and close?"
      );
      if (!confirmClose) return;
      this.cancelUpload();
    }

    this.resetUploadStates();
    this.setState({
      showDocumentModal: false,
      selectedTopic: null,
      selectedDocumentType: "",
      selectedFile: null,
    });
  };

  // Enhanced file remove handler
  handleFileRemove = () => {
    if (this.state.isUploading) {
      this.cancelUpload();
    }

    this.setState({
      selectedFile: null,
      totalBytes: 0,
    });

    this.resetUploadStates();
  };

  readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

  handleDeleteFile = async (containerName, blobName, video_id, topic_id) => {
    const result = await window.Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete "${blobName}". This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
        cancelButton: `btn font-weight-bold ${cancelClass}`,
      },
    });

    if (!result.isConfirmed) return;

    this.setState({ loading: true });

    try {
      await AzureStorageManage.deleteblob(containerName, blobName);
      await VideoService.deleteVideo(video_id,topic_id);

      this.showSuccessMessage(`File "${blobName}" deleted successfully!`);
      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Error deleting file:", error);
      this.showErrorMessage("Failed to delete file.");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleDeleteTopic = async (topic) => {
    const { topicDocuments } = this.state;
    const documents = topicDocuments.get(topic.topic_id) || [];
    const hasDocuments = documents.length > 0;

    // Prepare confirmation dialog content
    let confirmationText = `You are about to delete the topic "${topic.topic_name}".`;
    let confirmationHtml = "";

    if (hasDocuments) {
      const documentList = documents
        .map((doc) => `• ${doc.video_name}`)
        .join("<br>");

      confirmationText = `You are about to delete the topic "${topic.topic_name}" and all its videos.`;
      confirmationHtml = `
      <div style="text-align: left; margin-top: 15px;">
        <strong>The following ${documents.length} video${
        documents.length > 1 ? "s" : ""
      } will also be deleted:</strong>
        <div style="margin-top: 10px; padding: 10px; background-color: #f8f9fa; border-radius: 4px; max-height: 200px; overflow-y: auto;">
          ${documentList}
        </div>
      </div>
      <div style="margin-top: 15px; color: #d32f2f; font-weight: bold;">
        This action cannot be undone.
      </div>
    `;
    } else {
      confirmationText += " This action cannot be undone.";
    }

    // Show confirmation dialog
    const result = await window.Swal.fire({
      title: "Are you sure?",
      text: hasDocuments ? undefined : confirmationText,
      html: hasDocuments
        ? `<p>${confirmationText}</p>${confirmationHtml}`
        : undefined,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: hasDocuments
        ? "Yes, delete topic and all videos!"
        : "Yes, delete topic!",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
        cancelButton: `btn font-weight-bold ${cancelClass}`,
      },
      width: hasDocuments ? "600px" : undefined,
    });

    if (!result.isConfirmed) return;

    this.setState({ loading: true });

    try {
      if (hasDocuments) {
        await Promise.all(
          documents.map((doc) =>
            AzureStorageManage.deleteblob(
              doc.container_id,
              doc.video_name
            ).catch((e) => {
              console.error(`Failed to delete blob ${doc.video_name}:`, e);
              return Promise.resolve();
            })
          )
        );
      }

      // Delete topic and all associated documents from database
      // This method handles both cases: topics with documents and topics without documents
      await VideoService.deleteTopicBulkVideos(topic.topic_id);

      // Show success message
      const successMessage = hasDocuments
        ? `Collection "${topic.topic_name}" and ${documents.length} video${
            documents.length > 1 ? "s" : ""
          } deleted successfully!`
        : `Collection "${topic.topic_name}" deleted successfully!`;

      this.showSuccessMessage(successMessage);

      await this.loadTopicsAndDocuments();
    } catch (error) {
      console.error("Error deleting topic:", error);

      const errorMessage = hasDocuments
        ? "Failed to delete topic and videos. Some files may still exist."
        : "Failed to delete topic.";

      this.showErrorMessage(errorMessage);
    } finally {
      this.setState({ loading: false });
    }
  };

  // Utility Methods
  showSuccessMessage = (message) => {
    window.Swal.fire({
      title: "Success!",
      text: message,
      icon: "success",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
    });
  };

  showErrorMessage = (message) => {
    window.Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
    });
  };

  formatDate = (dateString) => {
    if (!dateString) return "";
    const utcString = dateString.includes("Z") ? dateString : dateString + "Z";
    const date = new Date(utcString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  formatTime = (dateString) => {
    if (!dateString) return "";
    const utcString = dateString.includes("Z") ? dateString : dateString + "Z";
    const date = new Date(utcString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  truncateFileName = (fileName, maxLength = 40) => {
    if (fileName.length <= maxLength) return fileName;
    const extension = fileName.substring(fileName.lastIndexOf("."));
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf("."));
    const truncatedLength = maxLength - extension.length - 3; // 3 for "..."
    return `${nameWithoutExt.substring(0, truncatedLength)}...${extension}`;
  };

  handleTopicCardClick = (topic) => {
    const { topicDocuments } = this.state;
    const documents = topicDocuments.get(topic.topic_id) || [];

    const selectedTopicData = {
      topic_id: topic.topic_id,
      topic_name: topic.topic_name,
      description: topic.topic_description || "",
      videoCount: documents.length,
      videos: documents.map((doc) => ({
        video_id: doc.video_id,
        video_name: doc.video_name,
        thumbnail: "",
        created_at: doc.created_at,
        container_id: doc.container_id,
        video_type: doc.video_type,
        duration: doc.duration,
        size_mb: doc.size_mb,
      })),
    };

    this.setState({
      showVideoStream: true,
      selectedTopicData,
    });
  };

  handleBackFromVideoStream = () => {
    this.setState({
      showVideoStream: false,
      selectedTopicData: null,
    });
  };

  // Render Methods
  renderTopicCard = (topic) => {
    const { topicDocuments, expandedTopics, editVisibility, deleteVisibility } =
      this.state;
    const documents = topicDocuments.get(topic.topic_id) || [];
    const isExpanded = expandedTopics.has(topic.topic_id);
    const documentCount = documents.length;

    const hasFullPrivileges = editVisibility && deleteVisibility;

    const cardStyle = {
      backgroundColor: "#fff",
      borderRadius: "16px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      border: "1px solid #e8e8e8",
      overflow: "hidden",
      transition: "all 0.3s ease",
      cursor: "pointer",
      height: "fit-content",
      display: "flex",
      flexDirection: "column",
    };

    const thumbnailStyle = {
      height: "180px",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const badgeStyle = {
      position: "absolute",
      top: "12px",
      right: "12px",
      backgroundColor: "rgba(0,0,0,0.7)",
      color: "#fff",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "500",
    };

    const buttonStyle = (borderColor, textColor) => ({
      backgroundColor: "transparent",
      border: `1px solid ${borderColor}`,
      borderRadius: "8px",
      padding: "6px 10px",
      fontSize: "12px",
      color: textColor,
      cursor: "pointer",
      transition: "all 0.3s ease",
    });

    const handleMouseEnter = (
      e,
      transform = "translateY(-8px)",
      shadow = "0 12px 40px rgba(0,0,0,0.15)"
    ) => {
      e.currentTarget.style.transform = transform;
      e.currentTarget.style.boxShadow = shadow;
    };

    const handleMouseLeave = (
      e,
      transform = "translateY(0)",
      shadow = "0 4px 20px rgba(0,0,0,0.08)"
    ) => {
      e.currentTarget.style.transform = transform;
      e.currentTarget.style.boxShadow = shadow;
    };

    const handleButtonHover = (e, bgColor, textColor) => {
      e.currentTarget.style.backgroundColor = bgColor;
      e.currentTarget.style.color = textColor;
    };

    const handleCardClick = (e) => {
      if (
        e.target.closest("button") ||
        e.target.closest("[data-no-card-click]")
      ) {
        return;
      }
      this.handleTopicCardClick(topic);
    };

    return (
      <div key={topic.topic_id} style={{ width: "100%" }}>
        <div
          className="collection-card"
          style={cardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleCardClick}
        >
          {/* Collection Thumbnail */}
          <div className="collection-thumbnail" style={thumbnailStyle}>
            <div style={badgeStyle}>{documentCount} videos</div>
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  display: "inline-block",
                  fontSize: "40px",
                  padding: "16px",
                  backgroundColor: "rgba(220, 53, 69, 0.9)",
                  borderRadius: "50%",
                  color: "#fff",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                  transition: "transform 0.2s ease, background-color 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "scale(1.1)";
                  e.currentTarget.style.backgroundColor =
                    "rgba(220, 53, 69, 1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.backgroundColor =
                    "rgba(220, 53, 69, 0.9)";
                }}
              >
                ▶️
              </div>
            </div>
          </div>

          {/* Collection Info */}
          <div
            className="collection-info"
            style={{
              padding: "20px",
              flex: "1",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ flex: "1" }}>
              <h5
                style={{
                  color: "#2c3e50",
                  fontWeight: "600",
                  marginBottom: "8px",
                  fontSize: "16px",
                  lineHeight: "1.4",
                }}
              >
                {topic.topic_name}
              </h5>
              {topic.topic_description && (
                <p
                  style={{
                    color: "#6c757d",
                    fontSize: "14px",
                    marginBottom: "16px",
                    lineHeight: "1.5",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {topic.topic_description}
                </p>
              )}
            </div>

            {/* Action Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "auto",
              }}
            >
              {/* Only show expand/collapse if user has full privileges */}
              {hasFullPrivileges && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    this.toggleTopicExpansion(topic.topic_id);
                  }}
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    fontWeight: "500",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  {isExpanded ? "🔼 Hide" : "🔽 Show"} Videos
                </span>
              )}

              <div style={{ display: "flex", gap: "8px" }}>
                {editVisibility && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleEditTopic(topic);
                    }}
                    style={buttonStyle("#6c757d", "#6c757d")}
                    onMouseEnter={(e) =>
                      handleButtonHover(e, "#6c757d", "#fff")
                    }
                    onMouseLeave={(e) =>
                      handleButtonHover(e, "transparent", "#6c757d")
                    }
                    title="Edit Collection"
                  >
                    ✏️ Edit
                  </button>
                )}

                {deleteVisibility && (
                  <Button
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleDeleteTopic(topic);
                    }}
                    style={buttonStyle("#dc3545", "#dc3545")}
                    onMouseEnter={(e) =>
                      handleButtonHover(e, "#dc3545", "#fff")
                    }
                    onMouseLeave={(e) =>
                      handleButtonHover(e, "transparent", "#dc3545")
                    }
                    title="Delete Collection"
                  >
                    <DeleteIcon fontSize="small" />
                  </Button>
                )}
              </div>
            </div>
          </div>

          {/* Expanded Content - Only show if user has full privileges */}
          {isExpanded && hasFullPrivileges && (
            <div
              className="collection-expanded"
              style={{
                borderTop: "1px solid #e8e8e8",
                backgroundColor: "#f8f9fa",
                animation: "expandContent 0.3s ease-out",
              }}
              data-no-card-click="true"
            >
              <div style={{ padding: "16px" }}>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleCreateDocument(topic);
                  }}
                  style={{
                    backgroundColor: "#dc3545",
                    border: "1px solid #dc3545",
                    color: "#fff",
                    borderRadius: "24px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#c82333";
                    e.currentTarget.style.borderColor = "#c82333";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#dc3545";
                    e.currentTarget.style.borderColor = "#dc3545";
                  }}
                >
                  🎥 Upload Videos
                </Button>
              </div>

              <div className="videos-list">
                {documents.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "32px 16px",
                      color: "#6c757d",
                    }}
                  >
                    <div style={{ fontSize: "32px", marginBottom: "8px" }}>
                      📹
                    </div>
                    <p style={{ margin: 0, fontSize: "14px" }}>
                      No videos uploaded yet
                    </p>
                  </div>
                ) : (
                  <div
                    style={{
                      maxHeight: "240px",
                      overflowY: "auto",
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                      position: "relative",
                    }}
                    onClick={(e) => {
                      // Prevent clicks in the videos list from bubbling up
                      e.stopPropagation();
                    }}
                  >
                    {documents.map((document, index) =>
                      this.renderDocumentCard(document, index)
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderDocumentCard = (document, index) => {
    const { deleteVisibility, editVisibility, selectedFiles } = this.state;
    const docType = DOCUMENT_TYPES[document.video_type] || DOCUMENT_TYPES.OTHER;
    const isSelected = selectedFiles.some(
      (file) => file.video_name === document.video_name
    );

    const hasFullPrivileges = editVisibility && deleteVisibility;

    console.log("Rendering document card for:", document); 

    const handleDeleteClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      console.log("Delete button clicked for:", document.video_name); // Debug log
      this.handleDeleteFile(
        document.container_id,
        document.video_name,
        document.video_id,
        document.topic_id
      );
    };

    return (
      <div
        key={`${document.video_id}-${index}`}
        className="video-item"
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #e8e8e8",
          transition: "all 0.3s ease",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#f1f3f4";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
        onClick={(e) => {
          // Prevent any click events from bubbling up from the document card
          e.stopPropagation();
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flex: "1",
            minWidth: 0,
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "36px",
              backgroundColor: "#000",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
              position: "relative",
              flexShrink: 0,
            }}
          >
            <span style={{ color: "#fff", fontSize: "14px" }}>▶️</span>
          </div>

          <div style={{ flex: "1", minWidth: 0 }}>
            <h6
              style={{
                color: "#2c3e50",
                fontWeight: "500",
                marginBottom: "4px",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {this.truncateFileName(document.video_name)}
            </h6>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "12px",
                color: "#6c757d",
              }}
            >
              <span
                style={{
                  backgroundColor: `${docType.color}20`,
                  color: docType.color,
                  padding: "2px 6px",
                  borderRadius: "4px",
                  fontSize: "10px",
                  fontWeight: "500",
                  marginRight: "8px",
                }}
              >
                {docType.name}
              </span>
              <span>
                {this.formatDate(document.created_at)} •{" "}
                {this.formatTime(document.created_at)}
              </span>
            </div>
          </div>
        </div>

        {hasFullPrivileges && (
          <div
            style={{
              marginLeft: "16px",
              flexShrink: 0,
              pointerEvents: "auto",
              position: "relative",
              zIndex: 10,
            }}
          >
            <button
              type="button"
              onClick={handleDeleteClick}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
              style={{
                backgroundColor: "#fff",
                border: "2px solid #dc3545",
                color: "#dc3545",
                padding: "8px 10px",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "12px",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "36px",
                minHeight: "36px",
                position: "relative",
                zIndex: 11,
                outline: "none",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#dc3545";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#dc3545";
                e.currentTarget.style.transform = "scale(1)";
              }}
              title="Delete Video"
            >
              <DeleteIcon fontSize="small" />
            </button>
          </div>
        )}
      </div>
    );
  };

  renderTopicModal = () => {
    const { showTopicModal, editingTopic, topicFormData, loadingModal } =
      this.state;

    // Validation logic
    const isNameValid =
      topicFormData.topic_name.trim().length > 0 &&
      topicFormData.topic_name.trim().length <= 128;
    const isDescriptionValid = topicFormData.topic_description.length <= 256;
    const isFormValid = isNameValid && isDescriptionValid;

    const nameCharCount = topicFormData.topic_name.length;
    const descriptionCharCount = topicFormData.topic_description.length;

    return (
      <Modal
        show={showTopicModal}
        onHide={this.handleCloseTopicModal}
        size="lg"
        centered
        //   style={{
        //     backdropFilter: "blur(10px)",
        //   }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          }}
        >
          <Modal.Header
            closeButton
            style={{
              borderBottom: "1px solid #e8e8e8",
              padding: "24px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <Modal.Title
              style={{
                color: "#2c3e50",
                fontWeight: "600",
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              🎬 {editingTopic ? "Edit Collection" : "Create New Collection"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "32px" }}>
            <div style={{ marginBottom: "24px" }}>
              <label
                htmlFor="topicName"
                style={{
                  fontWeight: "600",
                  color: "#2c3e50",
                  marginBottom: "8px",
                  display: "block",
                  fontSize: "14px",
                }}
              >
                Collection Name *
              </label>
              <input
                type="text"
                className="form-control"
                id="topicName"
                placeholder="Enter collection name (e.g., Mathematics Fundamentals)"
                value={topicFormData.topic_name}
                onChange={(e) =>
                  this.handleTopicFormChange("topic_name", e.target.value)
                }
                style={{
                  borderRadius: "12px",
                  border: `2px solid ${
                    !isNameValid && topicFormData.topic_name.trim().length > 0
                      ? "#dc3545"
                      : "#e8e8e8"
                  }`,
                  padding: "14px 16px",
                  fontSize: "14px",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocus={(e) => {
                  if (
                    isNameValid ||
                    topicFormData.topic_name.trim().length === 0
                  ) {
                    e.currentTarget.style.borderColor = "#dc3545";
                    e.currentTarget.style.boxShadow =
                      "0 0 0 3px rgba(220, 53, 69, 0.1)";
                  }
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor =
                    !isNameValid && topicFormData.topic_name.trim().length > 0
                      ? "#dc3545"
                      : "#e8e8e8";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "6px",
                  minHeight: "20px",
                }}
              >
                <div>
                  {!isNameValid &&
                    topicFormData.topic_name.trim().length > 0 && (
                      <small style={{ color: "#dc3545", fontSize: "12px" }}>
                        {topicFormData.topic_name.trim().length === 0
                          ? "Collection name is required"
                          : "Name must be 128 characters or less"}
                      </small>
                    )}
                  {topicFormData.topic_name.trim().length === 0 && (
                    <small style={{ color: "#dc3545", fontSize: "12px" }}>
                      Collection name is required
                    </small>
                  )}
                </div>
                <small
                  style={{
                    color: nameCharCount > 128 ? "#dc3545" : "#6c757d",
                    fontSize: "12px",
                  }}
                >
                  {nameCharCount}/128
                </small>
              </div>
            </div>

            <div>
              <label
                htmlFor="topicDescription"
                style={{
                  fontWeight: "600",
                  color: "#2c3e50",
                  marginBottom: "8px",
                  display: "block",
                  fontSize: "14px",
                }}
              >
                Collection Description
              </label>
              <textarea
                className="form-control"
                id="topicDescription"
                rows="4"
                placeholder="Describe this collection and what videos it will contain..."
                value={topicFormData.topic_description}
                onChange={(e) =>
                  this.handleTopicFormChange(
                    "topic_description",
                    e.target.value
                  )
                }
                style={{
                  borderRadius: "12px",
                  border: `2px solid ${
                    !isDescriptionValid ? "#dc3545" : "#e8e8e8"
                  }`,
                  padding: "14px 16px",
                  fontSize: "14px",
                  resize: "vertical",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocus={(e) => {
                  if (isDescriptionValid) {
                    e.currentTarget.style.borderColor = "#dc3545";
                    e.currentTarget.style.boxShadow =
                      "0 0 0 3px rgba(220, 53, 69, 0.1)";
                  }
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = !isDescriptionValid
                    ? "#dc3545"
                    : "#e8e8e8";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "6px",
                  minHeight: "20px",
                }}
              >
                <div>
                  {!isDescriptionValid && (
                    <small style={{ color: "#dc3545", fontSize: "12px" }}>
                      Description must be 256 characters or less
                    </small>
                  )}
                </div>
                <small
                  style={{
                    color: descriptionCharCount > 256 ? "#dc3545" : "#6c757d",
                    fontSize: "12px",
                  }}
                >
                  {descriptionCharCount}/256
                </small>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer
            style={{
              borderTop: "1px solid #e8e8e8",
              padding: "24px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <Button
              variant="secondary"
              onClick={this.handleCloseTopicModal}
              disabled={loadingModal}
              style={{
                borderRadius: "12px",
                padding: "10px 20px",
                fontWeight: "500",
                border: "2px solid #6c757d",
                backgroundColor: "transparent",
                color: "#6c757d",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.handleTopicSubmit}
              disabled={loadingModal || !isFormValid}
              style={{
                borderRadius: "12px",
                padding: "10px 20px",
                fontWeight: "500",
                backgroundColor: !isFormValid ? "#6c757d" : "#dc3545",
                border: `2px solid ${!isFormValid ? "#6c757d" : "#dc3545"}`,
                marginLeft: "12px",
                opacity: !isFormValid ? 0.6 : 1,
              }}
            >
              {loadingModal
                ? "Saving..."
                : editingTopic
                ? "Update Collection"
                : "Create Collection"}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    );
  };

  renderDocumentModal = () => {
    const {
      showDocumentModal,
      selectedDocumentType,
      selectedFile,
      selectedTopic,
      isUploading,
      uploadProgress,
      uploadStatus,
      uploadSpeed,
      timeRemaining,
      uploadedBytes,
      totalBytes,
      uploadError,
      canRetry,
      canCancel,
    } = this.state;

    return (
      <Modal
        show={showDocumentModal}
        onHide={this.handleCloseDocumentModal}
        size="lg"
        centered
        backdrop={isUploading ? "static" : true}
        keyboard={!isUploading}
      >
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          }}
        >
          <Modal.Header
            closeButton={!isUploading}
            style={{
              borderBottom: "1px solid #e8e8e8",
              padding: "24px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <Modal.Title
              style={{
                color: "#2c3e50",
                fontWeight: "600",
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              🎥 Upload Videos to {selectedTopic?.topic_name}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "32px" }}>
            {/* Document Type Selection */}
            {!isUploading && (
              <div style={{ marginBottom: "32px" }}>
                <label
                  style={{
                    fontWeight: "600",
                    color: "#2c3e50",
                    marginBottom: "16px",
                    display: "block",
                    fontSize: "14px",
                  }}
                >
                  Select Video Type *
                </label>
                <div className="row">
                  {Object.entries(DOCUMENT_TYPES).map(([key, type]) => (
                    <div key={key} className="col-md-6 mb-3">
                      <div
                        className={`video-type-option ${
                          selectedDocumentType === key ? "selected" : ""
                        }`}
                        onClick={() => this.handleDocumentTypeSelect(key)}
                        style={{
                          padding: "16px",
                          border: "2px solid",
                          borderColor:
                            selectedDocumentType === key
                              ? type.color
                              : "#e8e8e8",
                          borderRadius: "12px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          backgroundColor:
                            selectedDocumentType === key
                              ? `${type.color}10`
                              : "#fff",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <span style={{ fontSize: "24px", color: type.color }}>
                            {type.icon}
                          </span>
                          <span
                            style={{
                              fontWeight: "500",
                              color: "#2c3e50",
                              fontSize: "14px",
                            }}
                          >
                            {type.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* File Upload Area */}
            {selectedDocumentType && !isUploading && (
              <div
                className="upload-area"
                style={{
                  border: "2px dashed #dc3545",
                  borderRadius: "16px",
                  padding: "48px 32px",
                  textAlign: "center",
                  backgroundColor: "#fef7f7",
                  transition: "all 0.3s ease",
                }}
              >
                {!selectedFile ? (
                  <>
                    <div style={{ marginBottom: "16px" }}>
                      <span
                        style={{
                          fontSize: "64px",
                          color: DOCUMENT_TYPES[selectedDocumentType].color,
                        }}
                      >
                        {DOCUMENT_TYPES[selectedDocumentType].icon}
                      </span>
                    </div>
                    <h6
                      style={{
                        color: "#2c3e50",
                        marginBottom: "8px",
                        fontWeight: "600",
                      }}
                    >
                      Upload Your Video
                    </h6>
                    <p
                      style={{
                        color: "#6c757d",
                        marginBottom: "24px",
                        fontSize: "14px",
                      }}
                    >
                      Drag and drop your video file here, or click to browse
                    </p>
                    <div>
                      <input
                        type="file"
                        className="custom-file-input"
                        id="documentFileInput"
                        onChange={this.handleFileChange}
                        style={{ display: "none" }}
                      />
                      <label
                        className="btn btn-outline-primary"
                        htmlFor="documentFileInput"
                        style={{
                          borderRadius: "12px",
                          padding: "12px 24px",
                          fontWeight: "500",
                          border: "2px solid #dc3545",
                          backgroundColor: "#dc3545",
                          color: "#fff",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                      >
                        🎬 Choose Video File
                      </label>
                    </div>
                  </>
                ) : (
                  <div
                    className="selected-file"
                    style={{
                      backgroundColor: "#d4edda",
                      borderRadius: "12px",
                      border: "1px solid #c3e6cb",
                      padding: "20px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <span style={{ fontSize: "24px" }}>🎥</span>
                        <div>
                          <strong style={{ color: "#155724" }}>
                            {this.truncateFileName(selectedFile.name)}
                          </strong>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#6c757d",
                              marginTop: "4px",
                            }}
                          >
                            {this.formatFileSize(selectedFile.size)} - Ready to
                            upload
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={this.handleFileRemove}
                        style={{
                          backgroundColor: "#dc3545",
                          border: "none",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          color: "#fff",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                          transition: "all 0.3s ease",
                        }}
                        title="Remove file"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Upload Progress Section */}
            {isUploading && (
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "16px",
                  padding: "24px",
                  border: "1px solid #e9ecef",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "16px",
                  }}
                >
                  <div>
                    <h6
                      style={{ margin: 0, color: "#2c3e50", fontWeight: "600" }}
                    >
                      Uploading {selectedFile?.name}
                    </h6>
                    <small style={{ color: "#6c757d" }}>
                      {this.formatFileSize(uploadedBytes)} of{" "}
                      {this.formatFileSize(totalBytes)}
                    </small>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#007bff",
                      }}
                    >
                      {uploadProgress}%
                    </div>
                  </div>
                </div>

                {/* Progress Bar */}
                <div
                  style={{
                    width: "100%",
                    height: "12px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "6px",
                    overflow: "hidden",
                    marginBottom: "16px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      width: `${uploadProgress}%`,
                      height: "100%",
                      backgroundColor: "#007bff",
                      borderRadius: "6px",
                      transition: "width 0.3s ease",
                      background:
                        "linear-gradient(90deg, #007bff 0%, #0056b3 100%)",
                    }}
                  />
                </div>

                {/* Upload Stats */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "14px",
                    color: "#6c757d",
                  }}
                >
                  <span>Speed: {this.formatSpeed(uploadSpeed)}</span>
                  <span>
                    Time remaining: {this.formatTimeRemaining(timeRemaining)}
                  </span>
                </div>
              </div>
            )}

            {/* Upload Status Messages */}
            {uploadStatus === "success" && (
              <div
                style={{
                  backgroundColor: "#d4edda",
                  color: "#155724",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "1px solid #c3e6cb",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span style={{ fontSize: "24px" }}>✅</span>
                <div>
                  <strong>Upload Successful!</strong>
                  <div style={{ fontSize: "14px", marginTop: "4px" }}>
                    Your video has been uploaded and saved successfully.
                  </div>
                </div>
              </div>
            )}

            {uploadStatus === "error" && (
              <div
                style={{
                  backgroundColor: "#f8d7da",
                  color: "#721c24",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "1px solid #f5c6cb",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span style={{ fontSize: "24px" }}>❌</span>
                <div>
                  <strong>Upload Failed</strong>
                  <div style={{ fontSize: "14px", marginTop: "4px" }}>
                    {uploadError || "An error occurred during upload."}
                  </div>
                </div>
              </div>
            )}

            {uploadStatus === "cancelled" && (
              <div
                style={{
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "1px solid #ffeaa7",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <span style={{ fontSize: "24px" }}>⚠️</span>
                <div>
                  <strong>Upload Cancelled</strong>
                  <div style={{ fontSize: "14px", marginTop: "4px" }}>
                    The upload was cancelled by the user.
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer
            style={{
              borderTop: "1px solid #e8e8e8",
              padding: "24px",
              backgroundColor: "#f8f9fa",
            }}
          >
            {!isUploading ? (
              <>
                <Button
                  variant="secondary"
                  onClick={this.handleCloseDocumentModal}
                  style={{
                    borderRadius: "12px",
                    padding: "10px 20px",
                    fontWeight: "500",
                    border: "2px solid #6c757d",
                    backgroundColor: "transparent",
                    color: "#6c757d",
                  }}
                >
                  Cancel
                </Button>
                {canRetry ? (
                  <Button
                    variant="warning"
                    onClick={this.retryUpload}
                    style={{
                      borderRadius: "12px",
                      padding: "10px 20px",
                      fontWeight: "500",
                      backgroundColor: "#ffc107",
                      border: "2px solid #ffc107",
                      color: "#212529",
                      marginLeft: "12px",
                    }}
                  >
                    🔄 Retry Upload
                  </Button>
                ) : (
                  <Button
                    variant="primary"
                    onClick={this.handleDocumentUpload}
                    disabled={!selectedFile || !selectedDocumentType}
                    style={{
                      borderRadius: "12px",
                      padding: "10px 20px",
                      fontWeight: "500",
                      backgroundColor: "#dc3545",
                      border: "2px solid #dc3545",
                      marginLeft: "12px",
                    }}
                  >
                    🚀 Start Upload
                  </Button>
                )}
              </>
            ) : (
              <>
                <div
                  style={{
                    flex: 1,
                    textAlign: "left",
                    color: "#6c757d",
                    fontSize: "14px",
                  }}
                >
                  Upload in progress... Please don't close this window.
                </div>
                {canCancel && (
                  <Button
                    variant="danger"
                    onClick={this.cancelUpload}
                    style={{
                      borderRadius: "12px",
                      padding: "10px 20px",
                      fontWeight: "500",
                      backgroundColor: "#dc3545",
                      border: "2px solid #dc3545",
                    }}
                  >
                    ❌ Cancel Upload
                  </Button>
                )}
              </>
            )}
          </Modal.Footer>
        </div>
      </Modal>
    );
  };
  render() {
    const {
      topics,
      loading,
      addVisibility,
      editVisibility,
      selectedFiles,
      breadcrumb2,
      topicDocuments,
      showVideoStream,
      selectedTopicData,
    } = this.state;

    const path = history.location.pathname;
    const formattedBreadcrumb = breadcrumb2?.replaceAll(">", " > ") || "";
    const isTeacher = editVisibility || addVisibility;
    const totalDocuments = Array.from(topicDocuments.values()).reduce(
      (total, docs) => total + docs.length,
      0
    );

    const infoCard = (count, label, icon) => (
      <div className="col-md-6">
        <div
          style={{
            backgroundColor: "rgba(255,255,255,0.15)",
            borderRadius: "16px",
            padding: "20px",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,0.2)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <h3
                style={{
                  color: "#fff",
                  fontWeight: "700",
                  marginBottom: 4,
                  fontSize: 28,
                }}
              >
                {count}
              </h3>
              <p
                style={{
                  color: "rgba(255,255,255,0.8)",
                  margin: 0,
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {label}
              </p>
            </div>
            <div style={{ fontSize: 36, opacity: 0.6 }}>{icon}</div>
          </div>
        </div>
      </div>
    );

    const renderHeader = () => (
      <div
        className="streaming-header"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: 20,
          padding: 32,
          marginBottom: 32,
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {[
          { top: "-50%", right: "-10%", size: 300, opacity: 0.3 },
          { bottom: "-30%", left: "-5%", size: 200, opacity: 0.5 },
        ].map((circle, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              ...circle,
              width: circle.size,
              height: circle.size,
              background: "rgba(255,255,255,0.1)",
              borderRadius: "50%",
              opacity: circle.opacity,
            }}
          />
        ))}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
            position: "relative",
            zIndex: 2,
          }}
        >
          <div>
            <h1
              style={{
                color: "#fff",
                fontWeight: "700",
                marginBottom: 8,
                fontSize: 32,
                textShadow: "0 2px 4px rgba(0,0,0,0.2)",
              }}
            >
              🎬 SmartStream Learning
            </h1>
            {isTeacher ? (
              <p
                style={{
                  color: "rgba(255,255,255,0.9)",
                  fontSize: 16,
                  fontWeight: 400,
                }}
              >
                Create, organize, and share your video collections
              </p>
            ) : null}
          </div>

          {isTeacher && (
            <Button
              onClick={this.handleCreateTopic}
              style={{
                backgroundColor: "rgba(255,255,255,0.2)",
                border: "2px solid rgba(255,255,255,0.3)",
                color: "#fff",
                borderRadius: 16,
                padding: "12px 24px",
                fontSize: 14,
                fontWeight: 600,
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.3)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.2)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              ➕ Create Collection
            </Button>
          )}
        </div>

        <div className="row" style={{ position: "relative", zIndex: 2 }}>
          {infoCard(topics.length, "Video Collections", "📁")}
          {infoCard(totalDocuments, "Total Videos", "🎥")}
        </div>
      </div>
    );

    const renderEmptyState = () => (
      <div className="empty-state">
        <div style={{ marginBottom: 24 }}>
          <span
            style={{
              fontSize: 80,
              background: "linear-gradient(135deg, #ff6b6b, #ee5a24)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            🎬
          </span>
        </div>
        <h3
          style={{
            color: "#2c3e50",
            fontWeight: 600,
            fontSize: 24,
            marginBottom: 12,
          }}
        >
          No Collections Created Yet
        </h3>
        {isTeacher && (
          <>
            <p
              style={{
                color: "#6c757d",
                fontSize: 16,
                lineHeight: 1.5,
                marginBottom: 32,
              }}
            >
              Start building your video library by creating your first
              collection.
              <br />
              Organize your educational content by topics, subjects, or themes.
            </p>
            <Button
              onClick={this.handleCreateTopic}
              style={{
                background: "linear-gradient(135deg, #ff6b6b, #ee5a24)",
                border: "none",
                color: "#fff",
                borderRadius: 16,
                padding: "14px 28px",
                fontSize: 16,
                fontWeight: 600,
                boxShadow: "0 4px 15px rgba(238, 90, 36, 0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 25px rgba(238, 90, 36, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 15px rgba(238, 90, 36, 0.3)";
              }}
            >
              🎬 Create Your First Collection
            </Button>
          </>
        )}
      </div>
    );

    const renderTopicsGrid = () => (
      <div
        className="topics-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
          gap: "1.5rem",
          padding: "0 15px",
        }}
      >
        {topics.map((topic) => this.renderTopicCard(topic))}
      </div>
    );

    const renderCollections = () => (
      <div className="collections-container">
        {topics.length === 0 ? renderEmptyState() : renderTopicsGrid()}
      </div>
    );

    const renderMainContent = () => (
      <>
        {renderHeader()}
        {renderCollections()}
        {this.renderTopicModal()}
        {this.renderDocumentModal()}
      </>
    );

    // Handle video stream view
    if (showVideoStream && selectedTopicData) {
      return (
        <ManageVideoStream
          topicData={selectedTopicData}
          onBack={this.handleBackFromVideoStream}
          state={this.props.state}
        />
      );
    }

    return (
      <>
        <div
          style={{
            overflow: "auto",
            height: "90vh",
            backgroundColor: "#f8f9fa",
          }}
        >
          <ContentWrapper disabled={path === "/manage-search"}>
            {this.props.state.path !== "node" && (
              <p
                className="pt-4 pl-4"
                style={{ fontSize: 10.5625, color: "#00000099" }}
              >
                {formattedBreadcrumb}
              </p>
            )}

            <CardBody>
              {loading ? <VideoCollectionSkeleton /> : renderMainContent()}
            </CardBody>
          </ContentWrapper>
        </div>

        {/* Styles */}
        <style jsx>{`
          .collection-card:hover {
            transform: translateY(-8px) !important;
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
          }
          .video-item:hover {
            background-color: #f1f3f4 !important;
          }
          .video-type-option:hover,
          .video-type-option.selected {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
          .upload-area:hover {
            border-color: #c82333;
            background-color: #fdf2f2;
          }
          .streaming-header::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ... />');
            opacity: 0.3;
            pointer-events: none;
          }
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
            100% {
              transform: scale(1);
            }
          }
          .collection-card .collection-thumbnail .play-button {
            animation: pulse 2s infinite;
          }
          .btn:focus,
          .form-control:focus {
            box-shadow: none !important;
          }
          .form-control:focus {
            border-color: #dc3545 !important;
            box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
          }
          .modal-backdrop {
            backdrop-filter: blur(10px);
          }
        `}</style>
      </>
    );
  }
}

export default ManageVideos;
